import type { ActiveKey, Inspection } from '@/db/types'

export function normalizeSearchText(value: string): string {
  return value
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .trim()
    .toLocaleLowerCase('pt-BR')
    .replace(/\s+/g, ' ')
}

export function normalizePhone(value: string): string {
  return value.replace(/\D/g, '')
}

export function formatPhone(value: string): string {
  const digits = normalizePhone(value)
  if (digits.length !== 10 && digits.length !== 11) return digits
  return formatPhoneInput(digits)
}

export function formatPhoneInput(value: string): string {
  const digits = normalizePhone(value).slice(0, 11)
  if (!digits) return ''
  if (digits.length <= 2) return `(${digits}`
  const areaCode = digits.slice(0, 2)
  const subscriber = digits.slice(2)
  if (subscriber.length <= 4) return `(${areaCode}) ${subscriber}`
  const prefixLength = digits.length === 11 ? 5 : 4
  return `(${areaCode}) ${subscriber.slice(0, prefixLength)}-${subscriber.slice(prefixLength)}`
}

export function toActiveKey(active: boolean): ActiveKey {
  return active ? 1 : 0
}

export function inspectionSearchFields(
  inspection: Pick<Inspection, 'clientSnapshot' | 'machineSnapshot' | 'technicianSnapshot'>,
) {
  return {
    normalizedClientName: normalizeSearchText(inspection.clientSnapshot.companyName),
    normalizedClientPhone: normalizePhone(inspection.clientSnapshot.phone),
    normalizedFarmOrSite: '',
    normalizedMachineEquipment: normalizeSearchText(inspection.machineSnapshot.equipment),
    normalizedMachineBrand: normalizeSearchText(inspection.machineSnapshot.brand),
    normalizedMachineModel: normalizeSearchText(inspection.machineSnapshot.model),
    normalizedSerialChassis: normalizeSearchText(inspection.machineSnapshot.serialChassis),
    normalizedTechnicianName: normalizeSearchText(inspection.technicianSnapshot.name),
  }
}
